

import { motion } from "framer-motion";
import { Container } from "@/components/ui/Container";
import { Button } from "@/components/ui/Button";
import { fadeInUp } from "@/lib/motion";
import { useLanguage } from "@/components/LanguageContext";

export function ContactSection() {
  const { t } = useLanguage();

  return (
    <section className="py-24 lg:py-32 bg-warm-white relative overflow-hidden">
      {/* Decorative accent */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[1px] bg-gradient-to-r from-transparent via-amber/40 to-transparent" />

      <Container>
        <motion.div
          variants={fadeInUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-80px" }}
          className="relative max-w-4xl mx-auto text-center"
        >
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-amber mb-4">
            {t("Collaborons", "Let's Collaborate")}
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-semibold text-charcoal leading-tight text-balance">
            {t("Façonnons Ensemble l'Avenir de la Mobilité", "Let's Shape the Future of Mobility Together")}
          </h2>
          <p className="mt-5 text-base md:text-lg text-graphite-light leading-relaxed max-w-2xl mx-auto">
            {t(
              "Que vous ayez besoin d'une étude de mobilité, d'un diagnostic d'infrastructure, d'une analyse spatiale ou d'une plateforme analytique, notre équipe est prête à livrer des résultats d'impact.",
              "Whether you need a mobility study, an infrastructure diagnostic, a GIS analysis, or a custom analytics platform — our team is ready to deliver precision and impact."
            )}
          </p>
          <div className="mt-10 flex flex-wrap justify-center gap-4">
            <Button href="/contact" variant="primary" size="lg">
              {t("Demander un Devis", "Request a Quote")}
            </Button>
            <Button href="/services" variant="outline" size="lg">
              {t("Voir Nos Services", "View Our Services")}
            </Button>
          </div>
        </motion.div>
      </Container>
    </section>
  );
}
